import * as React from "react";
import { connect, ConnectedProps } from "react-redux";
import { RootState } from "../../../redux";
import { LanguageContext } from "../../../../../utilities/LocalizationModule";
import { expanderConstants } from "../../../redux/models/constants/expanders";
import ExpanderWithSubtitle from "../ExpanderWithSubtitle";
import { getRecentItems } from "../../../redux/modules/recentItems";
import HomeItem from "./HomeItem";
import { ModeEnum } from "../../enums/modeEnum";
import { IStoreItem } from "../../../interfaces/IStoredItem";
import { IPageSettings } from "../../../interfaces/IPageSettings";
import { Spinner } from "@fluentui/react/lib/Spinner";
import { IDialogContentProps } from "@fluentui/react";
import { ExpanderStateEnum } from "../../enums/expanderStateEnum";
import generalModule from "../../../../../utilities/GeneralModule";
import { Clock24Regular } from "../../_v2/components/SvgIcons/Clock24Regular";

const mapDispatchToProps = {
  getRecentItems
};

const mapStateToProps = (state: RootState) => {
  return {
    recent: state.recent,
    accountId: state.user?.account?.accountId,
    showRecent: state.user.settings.showRecent,
  };
};

const connector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;

interface RecentItemsProps extends PropsFromRedux {
  mode: ModeEnum;
  openFileOptions: (item: IStoreItem, isRecentList: boolean) => void;
  openFolderOptions: (item: IStoreItem, isRecentList: boolean) => void;
  showLicenseDialog: () => void;
  saveToOneDrive: (
    folderName: string,
    fromLocationItemCurrentDirectory?: IPageSettings,
    savingLocationDirectory?: string,
    locationBeforeSaving?: IPageSettings[]
  ) => Promise<void>;
  setLicenseMessageContent: (content: IDialogContentProps) => void;
}

const RecentItems: React.FunctionComponent<RecentItemsProps> = ({
  recent,
  mode,
  openFileOptions,
  openFolderOptions,
  showLicenseDialog,
  saveToOneDrive,
  accountId,
  getRecentItems,
  showRecent,
  setLicenseMessageContent
}: RecentItemsProps) => {
  const [expanderState, setExpanderState] = React.useState<ExpanderStateEnum>(ExpanderStateEnum.unset);

  const canToggle: boolean = generalModule.isInConentMangerMode() ? false : true; //Side menu - toggle/button

  //funcs
  React.useEffect(() => {
    if (showRecent && !recent.recentItems) {
      const initAsync = async () => {
        const recentCount = await getRecentItems(accountId, languageStrings);
        // if (recentCount > 0) {
        //   setExpanderState(ExpanderStateEnum.expanded);
        // }
      };
      initAsync();
    }
  }, [showRecent]);

  //consts
  const languageStrings = React.useContext(LanguageContext);

  const items: JSX.Element[] = recent.recentItems && recent.recentItems.map((item, index) => {
    return (
      <HomeItem
        key={index}
        homeItem={item}
        mode={mode}
        isRecentList={true}
        openFileOptions={openFileOptions}
        openFolderOptions={openFolderOptions}
        showLicenseDialog={showLicenseDialog}
        saveToOneDrive={saveToOneDrive}
        setLicenseMessageContent={setLicenseMessageContent}
      />
    );
  });

  const emptyMessage: JSX.Element[] = items?.length === 0 && [<p className="xb-empty-location-message centerText" key="0">{languageStrings.RecentItemsShownHere}</p>];

  return (
    <ExpanderWithSubtitle
      // iconName="Clock"
      iconElement={<Clock24Regular />}
      items={!canToggle ? [] : items?.length > 0 ? items : recent.isRecentItemsLoading ? [<Spinner key={0} />] : emptyMessage}
      title={languageStrings.Recent}
      expanderNameToToggle={expanderConstants.home.recent}
      hasShowMoreButton={true}
      expanderState={expanderState}
      canToggle={canToggle}
    />
  );
};

export default connector(RecentItems);
